import { getApproveDetail } from "@/api/approve/approve";
import { getDocumentStatus } from "@/api/seal/seal";
export const dingTalkNavigation = async (to) => {
  let toUrl;
  //审批详情页
  if (
    to.path == "/approveDetails" &&
    ![45, 46, 47].includes(Number(to.query.businessType))
  ) {
    let hasPending;
    const params = {
      dataId: to.query.documentId,
      processInstanceId: to.query.processInstanceId || null,
      taskId: to.query.taskId || null,
      processMold: to.query.processMold,
      recordType: to.query.recordType,
    };
    await getApproveDetail(params).then((res) => {
      if (res.success) {
        hasPending = res.data.hasPending;
      }
    });
    if (hasPending) {
      //待审批详情页
      toUrl = `/approval/notApproval/pendingdetail?type=0&id=${to.query.documentId}&dataId=${to.query.documentId}&taskId=${to.query.taskId}&recordType=${to.query.recordType}&processMold=${to.query.processMold}&processInstanceId=${to.query.processInstanceId}`;
    } else {
      //已审批详情页
      toUrl = `/approval/alreadyApproval/approveddetail?type=0&id=${to.query.documentId}&dataId=${to.query.documentId}&taskId=${to.query.taskId}&recordType=${to.query.recordType}&processMold=${to.query.processMold}&processInstanceId=${to.query.processInstanceId}`;
    }
  } else if (
    to.path == "/applyDetail" ||
    to.path == "/recordDetail" ||
    to.path == "/ocrDetail"
  ) {
    if (to.query.processMold == "3") {
      //刻章管理详情页
      toUrl = `/sealManage/engrave/detail?id=${to.query.id}`;
    } else if (
      to.query.processMold == "4" ||
      to.query.processMold == "5" ||
      to.query.processMold == "6" ||
      to.query.processMold == "7"
    ) {
      //印章操作申请记录
      toUrl = `/sealManage/operationRecord/detail?id=${to.query.id}&processInstanceId=${to.query.processInstanceId}&processMold==${to.query.processMold}`;
    } else {
      let documentId =
        to.query.id || to.query.documentId || to.query.businessId;
      let sealStatus;
      await getDocumentStatus({ documentId }).then((res) => {
        if (res.success) {
          sealStatus = res.data;
        }
      });
      if (sealStatus == 1 || sealStatus == 2) {
        //待用印详情页
        toUrl = `/seal/applyWaitList/detail?documentId=${documentId}&processInstanceId=${to.query.processInstanceId}`;
      } else if (sealStatus == 3 || sealStatus == 6) {
        //已完成详情页
        toUrl = `/seal/applyCompleteList/detail?documentId=${documentId}&processInstanceId=${to.query.processInstanceId}`;
      } else if (sealStatus == 5) {
        //已归档详情页
        toUrl = `/seal/applyArchiveList/detail?documentId=${documentId}&processInstanceId=${to.query.processInstanceId}`;
      } else {
        //用印申请详情页
        toUrl = `/seal/apply/detail?documentId=${documentId}`;
      }
      //电子签章
      if(to.query.digital == 'true'){
        //电子签章详情页
        toUrl = `/elecSeal/applyStamping/detail?documentId=${documentId}`;
      }
    }
  } else if (
    to.path == "/approveDetails" &&
    [45, 46, 47].includes(Number(to.query.businessType))
  ) {
    //申领记录详情页
    toUrl = `/itemManagement/itemProcess/detail?id=${to.query.documentId}&processMold=9`;
  } else if (to.path == "/informDetail") {
    //抄送我的
    toUrl = `/approval/informPeople/detail?dataId=${to.query.documentId}&processInstanceId=${to.query.processInstanceId}&&processMold=${to.query.processMold}`;
  } else if (to.path == "/warningDetail" || to.path == "/yzgMsgDetail") {
    //消息中心 -弹窗
    toUrl = `/messageCenter?messagePushId=${to.query.id}`;
  }
  else if (to.path == "/remoteConfirm") {
    //消息中心 -跳转至app查看
    toUrl = `/messageCenter?ToApp=true`;
  } else if (to.path == "/applyStampingDetail") {
    //电子签章详情页
    toUrl = `/elecSeal/applyStamping/detail?documentId=${to.query.documentId}`;
  }
  return toUrl;
};
